import axios from 'axios';

export default {
    fetchRoute(id) {
        return axios.post('/delivery/route/', {
            deliveryroute: id,
        });
    },
    updateRoute(routeId, name, description, configRules) {
        return axios.post('/delivery/updateRoute', {
            deliveryroute: routeId,
            name,
            description,
            configRules,
        });
    },
    addRoute(name, description, configRules) {
        return axios.post('/delivery/addRoute', {
            name,
            description,
            configRules,
        });
    },
    listRoutes() {
        return axios.post('/delivery/listRoutes');
    },
    deleteRoute(routeId) {
        return axios.post('/delivery/deleteRoute/', {
            deliveryroute: routeId,
        });
    },
};
